import dynamic from 'next/dynamic';
import { DownloadProgramProvider, useDownloadProgram } from './DownloadProgramContext';

const DownloadProgramLink = dynamic(() => import('./DownloadProgramLink'));
const DownloadProgramForm = dynamic(() => import('./DownloadProgramForm'));
const DownloadProgramModal = dynamic(() => import('./DownloadProgramModal'));

export default {
  Form: DownloadProgramForm,
  Link: DownloadProgramLink,
  Modal: DownloadProgramModal,
  Provider: DownloadProgramProvider,
  useDownloadProgram,
};
